import './style.css';
import { IconContext } from 'react-icons';
import RoomServiceIcon from '@mui/icons-material/RoomService';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { useGlobal } from '../../GlobalContext';
import LogoClienteFacilities from '../LogoClienteFacilities';
import { useNavigate, useLocation } from 'react-router-dom';
import ThemeToggle from '../ThemeToggle';
import { resolveClientColor } from '../../Utills/colors';

export function HeaderFacilities() {
  const { loading, error, menu } = useGlobal();
  const navigate = useNavigate();
  const location = useLocation();

  if (loading) return null;
  if (error) {
    console.error('Erro no contexto global:', error);
    return null;
  }

  const apartamento = menu?.additional_info?.apto || new URLSearchParams(location.search).get('x');
  const isHome = /^\/[^/]+\/?$/.test(location.pathname);
  const clientColor = resolveClientColor();

  return (
    <header className="header facilities-header">
      <div className="container">
        {!isHome && (
          <button onClick={() => navigate(-1)} className="btn-header-return" aria-label="Voltar">
            <ArrowBackIosIcon />
          </button>
        )}

        <LogoClienteFacilities />

        <div className="menu-icons" aria-label="Controles da hospedagem">
          <ThemeToggle />
          <IconContext.Provider value={{ size: '20px' }}>
            <div
              className="card_room"
              style={{ '--room-color': clientColor }}
              aria-label={`Apartamento ou mesa ${apartamento || ''}`}
            >
              <RoomServiceIcon />
              <p>{apartamento || '—'}</p>
            </div>
          </IconContext.Provider>
        </div>
      </div>
    </header>
  );
}
